<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-rss`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43.436 6c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54V20l-4 4V10H6v30h20l-4 4H4.564c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 01-.757-.756c-.174-.326-.267-.65-.267-1.54V8.563c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757.326-.174.65-.267 1.54-.267h38.873zM46 35v7a2 2 0 01-2 2h-7l9-9zm0-4.672v-5.657L26.672 43.999h5.657L46 30.328z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconRss',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
